import React, { Component } from 'react';
import AuditReport from './auditReportComponent'
class AuditReportPage extends Component {
    constructor(props) {
        super(props);
    }
    componentWillMount=()=>{
        this.props.changeShowHideSchoolFitler(true);
    }
    render() {
        const {selectSchool}=this.props;
        return (
            <div>
                <section>
                    <div className="container">
                        <div className="sectionTitle">
                            <h2>
                                <span>Reports</span>
                            </h2>
                        </div>
                        <div className="row ">
                      
                            <div style={{marginTop:60}}>
                                <div className="panel panel-p1 panel-primary">
                                    <div className="panel-heading text-center">
                                        <h3 className="panel-title">Reports</h3>
                                    </div>
                                    <div className="panel-body">
                                        <AuditReport selectSchool={selectSchool}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

export default AuditReportPage;


// WEBPACK FOOTER //
// ./src/components/District/auditReport/auditReport.jsx